import { render, staticRenderFns } from "./CommentSub.vue?vue&type=template&id=195cfe96&"
import script from "./CommentSub.vue?vue&type=script&lang=js&"
export * from "./CommentSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports